// TODO Change to pipe (similar as we have for container name)

export const getWeightBracketsHeader = (field: string, suffix = "kg") => {
  if (!field) {
    return;
  }

  if (field.match(/per/i)) {
    return "Per " + field.match(/\d+/)[0] + "kg";
  } else {
    field = field.replace(/lt/i, "< ");
    field = field.replace(/gt/i, "> ");
    field = field.replace("_", ".");

    return field + suffix;
  }
};
